<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    app
    class="drawer-background"
    mobile-break-point="960"
    floating
    width="262"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)"
      />
    </template>
    <div class="text-center py-2">
      <span 
        v-if="isToddOrg" 
        class="font-color font-size-40 font-calibri font-weight-medium"
      >
        SELAT
      </span>
      <span 
        v-else
        class="font-color font-size-40 font-calibri font-weight-medium"
      >
        FRANCO
      </span>
      <span class="font-color font-size-20 font-calibri">HR</span>
    </div>

    <v-divider class="mx-4 mb-4" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-group   
        class="dropdown-black"
        :value="expand"         
        no-action
        color="#000000"
      >
        <template v-slot:activator>
          <v-list-item-avatar color="#000000">
            <v-img :src="employee.thumbnail_url" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="font-weight-bold font-calibri font-black">
              {{ user.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="link in profileLinks"
          :key="link.title"
          :to="link.to"
          active-class="#000000"
          class="v-list-item"
          style="padding-left: 15px;margin-top:10px"
        >
          <v-list-item-action>
            <v-icon color="black">
              {{ link.action }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-title
            class="font-weight-bold font-calibri font-black"
            v-text="link.title"
          />
        </v-list-item>

        <div 
          v-show="systemSettingValue === '1'"
          class="mt-4 pb-2"
        >
          <template>
            <a
              class="ml-8"
              target="blank" 
              :href="workspaceLink"
            >
              <v-icon 
                color="purple"
              >
                mdi-link-variant
              </v-icon>
              <span class="pl-8">Workspace (HRM)</span>
            </a>
          </template>
        </div>
      </v-list-group>
    </v-list>

    <v-divider class="mx-4 mt-4" />

    <v-list class="py-2">
      <v-list-group
        v-for="(linkGroup,i) in filteredGroups"
        :key="linkGroup.title"
        :value="subExpand"
        color="#000000"
        class="dropdown-black"
      >
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon color="black">
              {{ linkGroup.action }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold font-calibri font-black">
              {{ linkGroup.title }}
              <v-avatar
                v-if="linkGroup.requireAttention && linkGroup.title === 'Leave' && pendingCount > 0"
                color="error"
                small
                size="7"
                class="mb-3"
              />
              <v-avatar
                v-if="linkGroup.requireAttention && linkGroup.title === 'Claim' && claimPendingCount > 0"
                color="error"
                small
                size="7"
                class="mb-3"
              />
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <div :id="'navVlist'+i">         
          <v-list-item
            v-for="(link, i) in linkGroup.links"
            :key="i"
            :to="link.to"
            active-class="#000000"
            :class="{
              'no-pm': link.subLinks
            }"
            style="margin-top:10px"
          >
            <v-list-group
              v-if="link.subLinks"
              :key="link.title"
              :value="deepExpand"
              sub-group
              class="sub-no-pl dropdown-black"
              color="#000000"
            >
              <template v-slot:activator>
                <v-list-item-title
                  class="font-weight-bold font-calibri font-black"
                >
                  {{ link.title }}
                </v-list-item-title>
              </template>
              <v-list-item
                v-for="(subLink, j) in link.subLinks"          
                :key="j"
                :to="subLink.to"
                active-class="#000000"
                style="padding-left:70px;margin-top:10px"
              >                
                <v-list-item-title
                  style="max-width: 120px;"
                  class="font-weight-bold font-calibri font-black text-truncate "
                >                
                  {{ subLink.title }}
                </v-list-item-title>
              </v-list-item>  
            </v-list-group>

            <v-list-item-title
              v-else
              class="font-weight-bold font-calibri font-black"
              style="padding-left: 56px"
            >
              {{ link.title }}
              <v-avatar
                v-if="link.hasCount && (link.to === '/leave-applications' && link.title === 'Approval') && pendingCount > 0"
                color="error"
                small
                size="20"
              > 
                <span class="caption white--text"> {{ pendingCount }} </span>
              </v-avatar>
              <v-avatar
                v-if="link.hasCount && (link.to === '/claim-approvals' && link.title === 'Approval') && claimPendingCount > 0"
                color="error"
                small
                size="20"
              > 
                <span class="caption white--text"> {{ claimPendingCount }} </span>
              </v-avatar>
            </v-list-item-title>
          </v-list-item> 
        </div>
      </v-list-group>
    </v-list>  
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import {
    mapMutations,
    mapState,
  } from 'vuex'

  export default {
    data: () => ({
      // fullPages: [
      //   '/leave-dashboard',
      // ],
      linkGroups: [
        {
          action: 'mdi-account-multiple-outline',
          title: 'Employee',
          links: [
            {
              to: '/employees-hris',
              title: 'Overview',
              permission: 'view hris employees',
              mobileView: false,
            },
            {
              to: '/notification-e-letters',
              title: 'E-Letter',
              permission: 'generate e-letters',
              mobileView: true,
            }, 
            {
              to: '/employee-reports',
              title: 'Report',
              permission: 'view employee reports',
              mobileView: true,
            },
          ],
        },
        {
          action: 'mdi-currency-usd',
          title: 'Payroll',
          links: [
            {
              to: '/payrolls',
              title: 'Transaction',
              mobileView: false,
              permission: 'view payroll transactions',
            },
            {
              to: '/payroll-payment-reports',
              title: 'Payment',
              mobileView: false,
              permission: 'view payroll payment reports',
            },
            {
              to: '/payroll-government-reports',
              title: 'Government', 
              mobileView: false,
              permission: 'view payroll government reports',
            },  
            {
              to: '/payroll-import',
              title: 'Template',
              permission: 'view payroll import',
              mobileView: true,
            },  
            {
              to: '/payroll-e-letters',
              title: 'E-Letter',
              permission: 'generate e-letters',
              mobileView: true,
            },  
            {
              to: '/payroll-reports',
              title: 'Report',
              mobileView: false,
              permission: 'view payroll reports',
            },            
          ],
        },
        {
          action: 'mdi-calendar',
          title: 'Leave',
          requireAttention: true,
          links: [
            {
              to: '/leave-dashboard',
              title: 'Dashboard',
              permission: 'view leave dashboard',
              mobileView: false,
            },
            {
              to: '/leave-on-behalf',
              title: 'Apply On Behalf',
              permission: 'view leaves on behalf',
              mobileView: false,
            },
            {
              to: '/leave-applications',
              title: 'Approval',
              permission: 'view leave approvals tab',
              hasCount: true,
              mobileView: false,
            },
            {
              to: '/leave-reports',
              title: 'Report',
              permission: 'view leave reports',
              mobileView: true,
            },            
          ],
        },
        {
          action: 'mdi-invoice-list',
          title: 'Claim',
          requireAttention: true,
          links: [
            {
              to: '/claim-approvals',
              title: 'Approval',
              permission: 'view claim approvals tab',
              hasCount: true,
              mobileView: false,
            },
            {
              to: '/approve-on-behalf',
              title: 'Approve On Behalf',
              permission: 'approve claim on behalf',
              mobileView: false,
            },
            {
              to: '/claim-on-behalf',
              title: 'Apply On Behalf',
              permission: 'apply claim on behalf',
              mobileView: false,
            },
            {
              to: '/claim-bulkpay',
              title: 'Payment',
              permission: 'generate claim bulk pay report',
              mobileView: false,
            }, 
            {
              to: '/claim-report',
              title: 'Report',
              permission: 'view claim reports',
              mobileView: false,
            }, 
          ],
        },
        {
          action: 'mdi-account-check',
          title: 'Probation',
          links: [
            {
              to: '/probations',
              title: 'List',
              permission: 'view probations',
              mobileView: false,
            },
            {
              to: '/probation-reports',
              title: 'Report',
              permission: 'view probation reports',
              mobileView: true,
            },            
          ],
        },          
        {
          action: 'mdi-calendar-clock',
          title: 'Duty Roster',
          links: [
            {
              to: '/duty-rosters',
              title: 'Calendar',
              permission: 'view duty rosters',
              mobileView: false,
            },
          ],
        },   
        {
          action: 'mdi-calendar-check',
          title: 'Attendance',
          links: [
            {
              to: '/attendances',
              title: 'Import & Sync',
              permission: 'view attendance import',
              mobileView: true,              
            },
            {
              to: '/attendance-reports',
              title: 'Report',
              permission: 'view attendance reports',
              mobileView: true,
            },            
          ],
        },   
        {
          action: 'mdi-cog',
          title: 'Setup',
          links: [
            {
              title: 'Claim',
              to: '/claim-setup',
              permission: 'view claim setup',
            },
            {
              title: 'Company',
              to: '/companies',
              permission: 'view companies',
            },
            {
              to: '/departments',
              title: 'Dept./Sec.',
              permission: 'view department section',
            },
            {
              title: 'Discipline',
              to: '/disciplines',
              permission: 'view discipline setup',
            },
            {
              title: 'Education',
              to: '/education',
              permission: 'view education',
            },
            {
              title: 'Holiday',
              to: '/holidays',
              permission: 'view holiday',
            },
            {
              title: 'Job Position',
              to: '/job-position',
              permission: 'view job position',
            },
            {
              title: 'Leave',
              to: '/leave-setup',
              permission: 'view leave setup',
            },
            {
              title: 'Notification',
              to: '/notification-setup',
              permission: 'view notification types',
            },
            {
              title: 'Office Location',
              to: '/office-locations',
              permission: 'setup office location view',
            },
            {
              title: 'Payroll',
              to: '/payroll-setup',
              permission: 'view payroll',
            },
            {
              title: 'Role',
              to: '/roles',
              permission: 'view roles',
            },
            {
              title: 'Separation',
              to: '/separation-types',
              permission: 'view separation types',
            },
            {
              title: 'Work Session',
              to: '/work-sessions',
              permission: 'view work session types',
            },
            {
              action: 'mdi-cog',
              title: 'System Setting',
              to: '/system-settings',
              permission: 'view system settings',
              mobileView: false,
            },
          ],
        },
        
      ],
      filteredGroups: [],
      expand: false,
      subExpand: false,
      deepExpand: false,
      appOrg: process.env.VUE_APP_ORG,
      isToddOrg: false,
      systemSettingValue: 0,
    }),
    computed: {
      workspaceLink () {
        switch (process.env.VUE_APP_ENV) {
          case 'local':
            return 'http://localhost:8081'
          case 'staging':
            return 'https://hrmtraining.trinitysearch.net'
          case 'production':
            return 'https://hrm.trinitysearch.net'
          default:
            return 'https://hrm.trinitysearch.net'
        }
      },
      ...mapState('app', ['image', 'color', 'pendingCount', 'claimPendingCount']),
      ...mapState({ user: 'currentUser', employee: 'currentEmployee' }),
      drawer: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      },
      profileLinks () {
        return [
          {
            to: '/profile',
            title: 'Profile',
            action: 'mdi-account',
            mobileView: true,
            visible: true,
          },
          {
            to: '/my-leave',
            title: 'Leave',
            action: 'mdi-calendar-account',
            mobileView: false,
            visible: true,
          },
          {
            to: '/my-payslip',
            title: 'Payslip',
            action: 'mdi-checkbook',
            mobileView: false,
            visible: true,
          },
          {
            to: '/my-ea',
            title: 'EA Form',
            action: 'mdi-file-document-outline',
            mobileView: false,
            visible: true,
          },
          {
            to: '/e-letter',
            title: 'Letter',
            action: 'mdi-email-open',
            mobileView: false,
            visible: true,
          },
          {
            to: '/my-attendance',
            title: 'Attendance',
            action: 'mdi-flag',
            mobileView: false,
            visible: true,
          },
          { 
            to: '/my-claim',
            title: 'Claim',
            action: 'mdi-hand-coin',
            mobileView: false,
            visible: this.employee.current_position && this.employee.current_position.position && !!this.employee.current_position.position.has_claim && this.employee.claim_types.length > 0,
          },
          {
            to: '/orgchart',
            action: 'mdi-lan',
            title: 'Organization Chart',
            mobileView: false,
            visible: true,
          },
        ].filter(link => link.visible)
      },
    },
    // watch: {
    //   $route: {
    //     immediate: true,
    //     handler (val) {
    //       if (this.fullPages.includes(val.path)) {
    //         this.setDrawer(false)
    //       }
    //     },
    //   }, 
    // }, 
    created () {
      this.getPendingLeaveApprovalCount()
      this.getPendingClaimApprovalCount()
      this.populateMenus()   
      this.isToddOrg = this.appOrg === 'todd'

      this.$api.systemSettings().list()
        .then(res => {
          this.systemSettingValue = res.data.find(setting => 
            setting.key === 'KATIMAS_WORKSPACE_INTEGRATION'
          ).value
        })
    },
    methods: {
      ...mapMutations('app', ['setDrawer', 'setPendingCount', 'setClaimPendingCount']),
      getPendingLeaveApprovalCount () {
        this.$api.leaveApprovals().pendingCount()
          .then(response => {
            this.setPendingCount(response.data)
          })
          .catch(() => {})
      },
      getPendingClaimApprovalCount () {
        this.$api.claimApprovals().pendingCount()
          .then(response => {
            this.setClaimPendingCount(response.data)
          })
          .catch(() => {})
      },
      populateMenus () {
        this.linkGroups.map(linkGroup => {
          const links = linkGroup.links.filter(link => {
            if (link.permission) {
              if (this.$vuetify.breakpoint.smAndDown) {
                if (this.$hasPermissionTo([link.permission]) && link.mobileView) return link
              } else {
                if (this.$hasPermissionTo([link.permission])) return link
              }
            } else {
              if (link.subLinks) {
                const subLinks = link.subLinks.filter(subLink => {
                  if (subLink.permission) {
                    if (this.$vuetify.breakpoint.smAndDown) {
                      if (this.$hasPermissionTo([subLink.permission]) && subLink.mobileView) return subLink
                    } else {
                      if (this.$hasPermissionTo([subLink.permission])) return subLink
                    }
                  } else return subLink
                })
                if (subLinks.length < 1) return 
                this.$set(link, 'subLinks', subLinks)
              }
              return link
            }       
          })
          if (links.length < 1) return
          this.$set(linkGroup, 'links', links)
          this.filteredGroups.push(linkGroup)
        })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important
}

.font-black{
  color:black !important
}

.no-pm{
  margin:unset !important;
  padding: unset !important;
}

.dropdown-black >>>  .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light{
  color:black !important
}

.dropdown-black >>> .v-list-group__header.v-list-item.v-list-item--link.theme--light .v-icon{
 color:black !important
}

.drawer-background{
 background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(215,255,255,1)) !important;
}

.font-color{
  color:#3796CF;
}
.font-size-40{
  font-size: 30px;
}
.font-size-20{
  font-size: 15px;
}
.font-calibri{
  font-family: calibri;
}
</style>
